module.exports = __webpack_public_path__ + "img/face-grin.e838f0a5.svg";